import type UserEducationStats from '@bloom/postgresql/entities/education/user-education-stats.entity';
import { API } from '../Client';

namespace EducationService {

  export async function getUser (id: string | undefined) {
    const res = await API.get<UserEducationStats>(`/education/user/${id}`);
    return res?.data;
  }
}


export default EducationService;